/**
 * Formats image URLs with Cloudflare image resizing if served from assets.auxodev.dk
 */
export function getOptimizedImageUrl(url, { width = 1200, quality = 80, height } = {}) {
  if (!url || typeof url !== 'string') return '';
  if (!url.includes('assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) {
    return url;
  }

  const parts = [];
  if (width) parts.push(`width=${width}`);
  if (height) parts.push(`height=${height},fit=cover`);
  parts.push(`quality=${quality}`);
  parts.push('format=auto');

  const optionsStr = parts.join(',');
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${optionsStr}/`);
}
